module.exports = {

  findObject: (array = [], key, condition = '') => {
    const result = array.find(element => element[key] === condition);
    return (result) || {};
  },

  formattedDate: (date) => {
    const convDate = new Date(date);
    const month = convDate.getMonth();
    const day = convDate.getDate();
    const year = convDate.getFullYear();
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return `${day}-${monthNames[month]}-${year}`;
  },

  formSortPayload(ascending) {
    if (ascending) return 'ASC';
    return 'DSC';
  },
};
